module.exports = __webpack_public_path__ + "static/media/designer.7509c42a.svg";